import { create } from 'zustand';

interface State {
  isCopyAccount: boolean;
  setIsCopyAccount: () => void;
}

const useAccountRegistStore = create<State>((set) => {
  return {
    isCopyAccount: false,
    setIsCopyAccount: () => set((state) => ({ isCopyAccount: !state.isCopyAccount })),
  };
});

export default useAccountRegistStore;
